module.exports = __webpack_public_path__ + "static/media/badgeProfessionality.ff4fcb89.png";